import {Pipe, PipeTransform} from '@angular/core';
import {FOLDER_STATES} from '../../../../views/pages/apps/Shared/Constants/folderStates';

@Pipe({
    name: 'translateState',
})
export class TranslateFolderStatePipe implements PipeTransform {

    /**
     * Translates a folder state code into a readable label
     * @param state Folder state code (e.g., 'EK_FOLDER_IN_PROGRESS')
     * @returns Human-readable label or empty string if not found
     */
    transform(state: string | null | undefined): string {
        if (!state) {
            return '';
        }

        const foundState = FOLDER_STATES.find(s => s.value === state);

        return foundState?.order + '. ' + foundState?.name ?? '';
    }
}